import React from 'react';
import { hasFlag } from 'country-flag-icons';
import * as Flags from 'country-flag-icons/react/3x2';

import { getCountryCode } from '@/core/utils/getCountryCode';

import styles from './CountryFlag.module.scss';

interface CountryFlagProps {
  countryName: string;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({ countryName }) => {
  const code = getCountryCode(countryName);

  if (!code || !hasFlag(code)) {
    return null;
  }

  const Flag = Flags[code as keyof typeof Flags];

  if (!Flag) {
    return null;
  }

  return <Flag className={styles.root} />;
};
